import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when route changes (better for SEO and UX)
    window.scrollTo(0, 0);
    
    // Send pageview to Google Analytics if available
    if (window.gtag) {
      window.gtag('config', 'G-517898989', {
        page_path: pathname,
      });
    }
    
    // Note: Document title is handled by SEO component via react-helmet-async
    // Do NOT set document.title here as it overrides the SEO component
  }, [pathname]);

  return null;
};

export default ScrollToTop;
